var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTyre(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.72 8C14.72 11.7114 11.7114 14.72 8 14.72C4.28865 14.72 1.28 11.7114 1.28 8C1.28 4.28865 4.28865 1.28 8 1.28C11.7114 1.28 14.72 4.28865 14.72 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.52 7.99997C11.52 9.94401 9.94401 11.52 7.99997 11.52C6.05593 11.52 4.47997 9.94401 4.47997 7.99997C4.47997 6.05593 6.05593 4.47997 7.99997 4.47997C9.94401 4.47997 11.52 6.05593 11.52 7.99997ZM12.8 7.99997C12.8 10.6509 10.6509 12.8 7.99997 12.8C5.349 12.8 3.19997 10.6509 3.19997 7.99997C3.19997 5.349 5.349 3.19997 7.99997 3.19997C10.6509 3.19997 12.8 5.349 12.8 7.99997Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTyre);
export default __webpack_public_path__ + "static/media/Tyre.06547cc053651a4890dab1756b2a82da.svg";
export { ForwardRef as ReactComponent };